import {ref, type Ref} from "vue";

import type {DSVueComponentWithRef} from "@songfinch/types";

export const usePositionElement = () => {
    const arrowPosition = ref("center");

    const positionDropdown = (
        dropdownWrapperRef: Ref<DSVueComponentWithRef | null>,
        dropdownRef: Ref<DSVueComponentWithRef | null>
    ) => {
        const dropdownWrapperContainerRef = dropdownWrapperRef.value?.containerRef;
        const dropdownContainerRef = dropdownRef.value?.containerRef;
        if (!dropdownWrapperContainerRef || !dropdownContainerRef) return;
        
        const dropdownRect = dropdownWrapperContainerRef.getBoundingClientRect();
        const listRect = dropdownContainerRef.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const minEdgeSpacing = 8; // Minimum spacing from edge of screen
        
        // Reset positions
        dropdownContainerRef.style.left = "";
        dropdownContainerRef.style.right = "";
        dropdownContainerRef.style.top = "";

        // Position dropdown below the button
        const topPosition = dropdownRect.height + 16; // 4px gap
        dropdownContainerRef.style.top = `${topPosition}px`;

        // Center by default
        const leftPosition = (dropdownRect.width - listRect.width) / 2;
        
        // Check if dropdown would overflow right edge
        if (dropdownRect.left + leftPosition + listRect.width > viewportWidth - minEdgeSpacing) {
            // Align to right with minimum spacing
            const rightPosition = Math.min(0, viewportWidth - (dropdownRect.right + minEdgeSpacing));
            dropdownContainerRef.style.left = "auto";
            dropdownContainerRef.style.right = `${rightPosition}px`;
            arrowPosition.value = "right";
        } 
        // Check if dropdown would overflow left edge
        else if (dropdownRect.left + leftPosition < minEdgeSpacing) {
            // Align to left with minimum spacing
            const leftPos = Math.max(0, minEdgeSpacing - dropdownRect.left);
            dropdownContainerRef.style.left = `${leftPos}px`;
            dropdownContainerRef.style.right = "auto";
            arrowPosition.value = "left";
        } 
        else {
            // Center
            dropdownContainerRef.style.left = `${leftPosition}px`;
            dropdownContainerRef.style.right = "auto";
            arrowPosition.value = "center";
        }
    };

    return {
        positionDropdown,
        arrowPosition
    };
};